import React, {useEffect, useState} from 'react';
import utils from "../services/utils";
import managecookies from "../services/managecookies";
import {logDOM} from "@testing-library/react";
import Loading from "../comps/Loading";
import '../style/css/settingmodal.css'
import GeneralManage from "../comps/GeneralManage";
import AreaManage from "../comps/AreaManage";
import BusinessWeekScheduler from "../comps/BusinessWeekScheduler";
import Permissions from "./Permissions";
import Holidays from "../comps/Holidays";
import SeatManagement from "../comps/SeatManagement";
import MessageManagement from "../comps/MessageManagement";

function SettingsModal(props) {
    const [userData, setUserData] = useState([])
    const [sectionView, setSectionView] = useState('general')

    const renderBusiness = () => {
        return userData.business.map(bus => (
            <option key={bus.businessToken} value={bus.businessToken}>
                {bus.names[0].name}
            </option>
        ));
    };

    const handleChangeBus = () => {
        // Your business switching logic
    };

    const renderUserInfo = () => {
        return <span>{userData.privateName} {userData.lastName}</span>
    }


    useEffect(() => {
        const data = JSON.parse(managecookies.getCookieVal('userData'));
        setUserData(data);
    }, []);

    const renderSettingView = () => {
        switch (sectionView) {
            case 'general':
                return <GeneralManage
                    renderBusiness={renderBusiness}
                    handleChangeBus={handleChangeBus}/>
            case 'areas':
                return <AreaManage/>
            case 'setting':
                return <BusinessWeekScheduler/>
            case 'premissions':
                return <Permissions/>
            case 'holidays':
                return <Holidays/>
            case 'seatanagement':
                return <SeatManagement/>
            case 'messageanagement':
                return <MessageManagement/>

        }
    }


    if (userData.length < 1) {
        return <Loading/>; // Or some other loading indicator
    }
    return (
        <div className={'setttings-container-modal'}>
            <section className="side-menu">
                <ul className="menu-list">
                    <li onClick={() => setSectionView('general')}>{utils.useLang('GENERAL')}</li>
                    <li onClick={() => setSectionView('areas')}>{utils.useLang('AREA_MANAGMENT')}</li>
                    <li onClick={() => setSectionView('setting')}>{utils.useLang('BUSINESS_OPEN_TIME')}</li>
                    <li onClick={() => setSectionView('seatanagement')}>{utils.useLang('SEAT_MANAGEMENT')}</li>
                    <li onClick={() => setSectionView('messageanagement')}>{utils.useLang('MESSAGE_MANAGEMENT')}</li>
                    <li onClick={() => setSectionView('premissions')}>{utils.useLang('PERMISSIONS')}</li>
                    <li onClick={() => setSectionView('holidays')}>{utils.useLang('HOLIDAYS')}</li>
                </ul>
            </section>
            <div className={'area-full-container'}>
                {renderSettingView()}
            </div>
        </div>
    );
}

export default SettingsModal;